import axios from 'axios'
import router from './../router'
export default {
  initializeAxios ({ commit }, userJwtToken) {
    const authAxios = axios.create({
      baseURL: '/api/',
      headers: {
        Authorization: `Bearer ${userJwtToken}`
      }
    })
    authAxios.interceptors.response.use(
      response => response, // Xử lý phản hồi thành công
      error => {
        // Kiểm tra nếu mã trạng thái là 401 hoặc 403
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          commit('backToLogin')
          localStorage.removeItem('storeLocal') // Xóa token hoặc thông tin xác thực khỏi local storage

          router.push({ path: '/login' }) // Chuyển hướng đến trang đăng nhập
        }

        // Trả lỗi cho các phần khác của ứng dụng
        return Promise.reject(error)
      }
    )

    commit('setAuthAxios', authAxios)
  }
}
